


















































































































import Vue, { PropOptions } from 'vue';
import {NOC, moment} from '@/class';
import {IOptionValue} from '@/class/models/typed/gadget/basicGadget';

import Charts from '@/components/charts';
import ListChart from '@/components/charts/ListChart.vue';
import SelectBox, {IOption} from '@/components/util/SelectBox.vue';
import GadgetFrame, {IFrame as iframe, CFrame} from './GadgetFrame.vue';

import DatePicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';

import ClickOutside from 'vue-click-outside';

// const EDIT = 'EDIT';
// const NODATA = 'NODATA';

export interface IGraph {
 key: string;
 lable: string;
 src: string;
}

export type IFrame = iframe;
export {
  CFrame,
};

export const VUECHARTGRAPH = [
  {key: NOC.CHARTS.BAR, lable: '縦棒グラフ', src: '/images/g/1.png' },
  {key: NOC.CHARTS.HORIZONTALBAR, lable: '横棒グラフ', src: '/images/g/2.png'},
  {key: NOC.CHARTS.PIE, lable: '円グラフ', src: '/images/g/3.png'},
  // {key: NOC.CHARTS.POLARAREA, lable: '強調円グラフ', src: '/images/g/4.png'},
  {key: NOC.CHARTS.RADAR, lable: 'レーダーチャート', src: '/images/g/5.png'},
  {key: NOC.CHARTS.LINE, lable: 'ライングラフ', src: '/images/g/6.png'},
  {key: NOC.CHARTS.LIST, lable: 'リスト', src: '/images/g/7.png'},
  {key: NOC.CHARTS.DOUGHNUT, lable: 'ドーナッツグラフ', src: '/images/g/8.png'},
  // {text: NOC.CHARTS.BUBBLE, icon: 'fa-braille'},
  // {text: NOC.CHARTS.SCATTER, icon: 'fa-question', name: 'バブル'},
] as IGraph[];

// 通信
import API from '@/api/common';
// const api = new API();
import * as models from '@/class/models/views/graph';

const GRAPH_HW = 248;

export default Vue.extend({
  name: 'BasicGadget',
  components: { GadgetFrame, SelectBox, ListChart, DatePicker },
  props: {
    baseFrameData: Object as PropOptions<IFrame>,
    gadgetData: Object as PropOptions<models.IGadget>,
    w: Number,
    h: Number,
    resized: {
      type: Boolean,
      default: true,
    },
    dashBoard: {
      type: Boolean,
      default: false,
    },
    selectErea: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      frameData: {} as IFrame,
      preTargetSetDataValue: '',
      targetSetDataValue: '',
      targetSetDataShow: false,
      targetSetDataOptions: [] as IOption[],
      targetSetDataInitialValue: '0',
      preTargetDateValue: '',
      targetDateValue: '',
      targetDateType: '',
      targetDateShow: false,
      targetDateInitialValue: '',
      materials: [] as models.IDomain[],
      selectGraphs: [] as models.IDomain[],
      selectGraphValue: '',
      resData: {} as models.VReturnGraphData,
      charts: Charts,
      DatePickerMonth: 'yyyy年MM月',
      DatePickerDate: 'yyyy/MM/dd',
      ja,
      /*
      dataObj: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [40, 39, 10, 40, 39, 80, 40],
          },
        ],
      },
      */
      dataObj: {},
      optionsObj: {},
      baseOptionsObj: {
        responsive: !this.dashBoard,
        maintainAspectRatio: !this.dashBoard,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{display: false, value: {}, ticks: {}}],
          xAxes: [{display: false, value: {}, ticks: {}}],
        },
      },
      widthX: GRAPH_HW,
      heightX: GRAPH_HW,
      loading: false,
      requestDataBack: '',
      options: {},
      optionItems: [] as any[],
      selectorshow: false,
    };
  },
  computed: {
    /*
    NO_DATA() {
      return NODATA;
    },
    */
    YEAR_OPTIONS() {
      return [2020, 2021, 2022, 2023, 2024, 2025].map((v) => ({text: String(v) , value: v}));
    },
    YEAR_SELECT() {
      const today = new Date();
      return ['一昨年', '昨年', '今年'].map((v, index) => (
        {text: String(v) , value: today.getFullYear() - 2 + index}
      ));
    },
    MONTH_SELECT() {
      const today = new Date();
      today.setMonth(today.getMonth() - 2);
      return ['先々月', '先月', '今月'].map((v, index) => {
        today.setMonth(today.getMonth() + 1);
        if (today.getMonth() === 0) {　// 今月が１月の場合の先月
          return {text: String(v) , value: `${today.getFullYear() - 1}-12`}; // 先月だけ年を1減らし月を12にする
        } else {
          return {text: String(v) , value: `${today.getFullYear()}-${('0' + today.getMonth()).slice(-2)}`};
        }
      });
    },
    DAY_SELECT() {
      const today = new Date();
      today.setDate(today.getDate() - 3);
      return ['一昨日', '昨日', '今日'].map((v, index) => {
        today.setDate(today.getDate() + 1);
        return {text: String(v) , value: `${today.getFullYear()}-${('0' + (today.getMonth() + 1)).slice(-2)}-${today.getDate()}`};
      });
    },
  },
  directives: {
    DatePicker,
    ClickOutside,
  },
  watch: {
    options: {
      deep: true,
      async handler(newValue: any) {
        if (this.resData.graphData) {
          this.setChartJsData(this.resData.graphData);
        }
        // console.log('aaa');
        this.$emit('setOptions', this.options);
      },
    },
    gadgetData: {
      deep: true,
      async handler(newValue: models.IGadget) {
        this.setGadgetData(newValue);
        /*
        // console.log('gedagetData change');
        // initial value set
        this.targetSetDataInitialValue = newValue.data.values.setData;
        this.targetDateInitialValue = newValue.data.values.date;
        // materials
        this.materials = JSON.parse(JSON.stringify(newValue.data.materials));
        // graph
        // this.selectGraphName = newValue.data.graph.value;
        console.log('newValue.options', newValue.options)
        this.options = JSON.parse(JSON.stringify(newValue.options));
        if (newValue.data.graph.length > 0 ) {
          if (this.selectGraphValue !== newValue.data.graph[0].key) {
            this.selectGraphValue = newValue.data.graph[0].key;
            this.selectGraphs = newValue.data.graph;
            // options成型
            this.optionItems = NOC.OPTION.V1.createChoices(this.selectGraphValue, this.materials);
            this.options = NOC.OPTION.V1.createOptions(this.options, this.optionItems);
            if (this.resData.graphData) {
              this.setChartJsData(this.resData.graphData);
            }
          }
        } else {
          this.selectGraphs = [];
          this.selectGraphValue = '';
        }
        */
      },
    },
    async materials(newValue: models.IDomain[], oldValue: models.IDomain[]) {
      // console.log('material check');
      let changeFlag = false;
      // target setdata
      {
        const newMatrerial = NOC.MATERIAL.V3.getTargetSetData(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getTargetSetData(oldValue);
        // const newMatrerial = newValue.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TARGET && v.kingdom === NOC.MATERIAL.V3.KINGDOM.SETDATA));
        // const oldMatrerial = oldValue.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TARGET && v.kingdom === NOC.MATERIAL.V3.KINGDOM.SETDATA));
        // console.log('targetSetdata check');
        if (JSON.stringify(newMatrerial) !== (JSON.stringify(oldMatrerial))) {
          await this.setSelectSetData(newMatrerial);
          changeFlag = true;
        }
      }
      // target date
      {
        const newMatrerial = NOC.MATERIAL.V3.getTargetDate(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getTargetDate(oldValue);
        // const newMatrerial = newValue.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TARGET && v.kingdom === NOC.MATERIAL.V3.KINGDOM.DATE));
        // const oldMatrerial = oldValue.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TARGET && v.kingdom === NOC.MATERIAL.V3.KINGDOM.DATE));
        // console.log('targedate check');
        if (JSON.stringify(newMatrerial) !== (JSON.stringify(oldMatrerial))) {
          this.setSelectDate(newMatrerial);
          this.checkDetail();
          changeFlag = true;
        }
      }
      // measure
      {
        const newMatrerial = NOC.MATERIAL.V3.getMeasures(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getMeasures(oldValue);
        // const newMatrerial = newValue.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.MEASURE));
        // const oldMatrerial = oldValue.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.MEASURE));
        if (JSON.stringify(newMatrerial) !== (JSON.stringify(oldMatrerial))) {
          changeFlag = true;
        }
      }
      // dimension date
      {
        const newMatrerial = NOC.MATERIAL.V3.getDimension(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getDimension(oldValue);
        // const newMatrerial = newValue.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.DIMENSION));
        // const oldMatrerial = oldValue.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.DIMENSION));
        if (JSON.stringify(newMatrerial) !== (JSON.stringify(oldMatrerial))) {
          changeFlag = true;
        }
      }
      // console.log('changeFlag', changeFlag)
      if (changeFlag) {
        // option設定s
        this.setOptions();
        // データ取得処理
        this.getBasicGraphData();
      }
    },
    async targetSetDataValue() {
      // console.log('targetSetDataValue');
      // グラフ追加対応：preTargetxxxを追加
      // 同時に複数回呼び出されるので2回目以降は回避
      if (this.preTargetSetDataValue !== '' && this.preTargetSetDataValue !== this.targetSetDataValue) {
      this.$emit('setValues', [this.gadgetData, {setData: this.targetSetDataValue, date: this.targetDateValue} as models.IValues]);
      }
      await this.getBasicGraphData();
      this.preTargetSetDataValue = this.targetSetDataValue;
    },
    targetDateValue(to) {
      if (this.targetDateType === '日') {
        this.targetDateValue = moment.fncChangeDateToInputForm(new Date(this.targetDateValue));
      } else if (this.targetDateType === '月') {
        this.targetDateValue = moment.fncChangeMonthToInputForm(new Date(this.targetDateValue));
      }
      // 同時に複数回呼び出されるので2回目以降は回避
      if (this.preTargetDateValue !== '' && this.preTargetDateValue !== this.targetDateValue) {
        this.$emit('setValues', [this.gadgetData, {setData: this.targetSetDataValue, date: this.targetDateValue} as models.IValues]);
        this.getBasicGraphData();
      }
      this.preTargetDateValue = this.targetDateValue;
      // console.log(this.targetDateValue);
    },
    w() { this.setSize(); },
    h() { this.setSize(); },
  },
  async mounted() {
    // this.frameSettings
    // console.log('Basic Gadget Moutend');
    // console.log('this.gadgetData', this.gadgetData);
    // データがある場合設定処理
    this.frameData = JSON.parse(JSON.stringify(this.baseFrameData));
    // options
    this.options = JSON.parse(JSON.stringify(this.gadgetData.options));
    this.setSize();
    if (this.gadgetData.data) {
      this.setGadgetData(this.gadgetData);
    }
  },
  methods: {
    // detail show flag
    checkDetail() {
      // todo:props objectで変えているがルール違反
      // console.log('detail');
      this.frameData.detail = false;
      const measureDate = NOC.MATERIAL.V3.getTargetDate(this.materials);
      // console.log(measure);
      if (measureDate) {
        // if ( measureDate.key === '日' ) { // ログ一括DL対応：日以外も作業ログ表示
          // console.log(measure.key);
        const measureSetData = NOC.MATERIAL.V3.getTargetSetData(this.materials);
        if (measureSetData) {
          if ( measureSetData.key === 'メンバー') {
            this.frameData.detail = true;
          }
        }
        // }
      }
    },
    setGadgetData(gadgetData: models.IGadget) {
      // initialValue
      if (gadgetData.data.values) {
        this.targetSetDataInitialValue = gadgetData.data.values.setData;
        this.targetDateInitialValue = gadgetData.data.values.date;
      }
      // this.targetSetDataValue = gadgetData.data.values.date;
      // materials
      this.materials = JSON.parse(JSON.stringify(gadgetData.data.materials));
      // graph
      if (gadgetData.data.graph.length > 0 ) {
        if (this.selectGraphValue !== gadgetData.data.graph[0].key) {
          this.selectGraphValue = gadgetData.data.graph[0].key;
          this.selectGraphs = gadgetData.data.graph;
          this.setOptions();
          if (this.resData.graphData) {
            this.setChartJsData(this.resData.graphData);
          }
        }
      } else {
        this.selectGraphs = [];
        this.selectGraphValue = '';
      }
    },
    async setSelectSetData(newDomain: models.IDomain | undefined) {
      this.targetSetDataShow = false;
      let options = [NOC.SELECT.NOSELECT] as IOption[];
      let initialValue = '0';
      if (newDomain) {
        const api = new API();
        const res = await api.post<models.IDomain, IOption[]>('gadget/ct1', newDomain);
        if (res.result) {
          if (res.data.length > 0) {
            options = options.concat(res.data);
            // show = true;
            this.targetSetDataShow = true;
            // console.log('this.targetSetDataShow', this.targetSetDataShow);
          }
        }
        this.loading = false;
      }
      // this.targetSetDataShow = show;
      // this.targetSetDataInitialValue = initialValue;
      // todo 初期値が性格かどうか見る
      // 初期値の有無
      // console.log('targetSetDataInitialValue', this.targetSetDataInitialValue);
      if (this.targetSetDataInitialValue !== '0') {
        // console.log('a')

        // await this.getBasicGraphData();
        initialValue = this.targetSetDataInitialValue;
      }
      this.targetSetDataOptions = options;
      this.targetSetDataValue = initialValue;
    },
    setSelectDate(newDomain: models.IDomain | undefined) {
      let type = '';
      let value = '';
      let show = false;
      if (newDomain) {
        type = newDomain.key;
        show = true;
        // console.log(this.targetDateInitialValue);
        if (this.targetDateInitialValue) {
          value = this.targetDateInitialValue;
          // console.log('set', value)
        } else {
          // typeに応じた初期値
          value = moment.fncGetLastMonthDateStr();
          switch (newDomain.id) {
            case 4:
              value = value.substr(0, 4);
              break;
            case 5:
              // console.log(value);
              value = value.substr(0, 7);
              break;
            case 6:
              break;
          }
        }
      }
      this.targetDateType = type;
      this.targetDateValue = value;
      this.targetDateShow = show;
    },
    setSize() {
      this.heightX = GRAPH_HW * this.h;
      this.widthX = GRAPH_HW * this.w;
    },
    trashAction() {
      this.$emit('trash');
    },
    async detailAction() {
      // this.$emit('showDetail', this.materials);
      // console.log('detail');
      const detailData = {
        setData: this.targetSetDataValue,
        date: this.targetDateValue,
      } as models.IValues;
      // console.log(detailData);
      this.$emit('showDetail', detailData);
    },
    async getBasicGraphData() {
      // console.log('get basic graph', this.selectGraphValue);
      // console.log('this.materials', this.materials);
      try {
        this.frameData.error = false;
        this.resData = {} as models.VReturnGraphData;
        if (this.selectGraphValue !== '') {
          // 各種値がない時は取得しない
          if (NOC.MATERIAL.V3.getTargets(this.materials).length <= 0) {
            // console.log('no targets');
            return;
          }
          if (NOC.MATERIAL.V3.getMeasures(this.materials).length <= 0) {
            // console.log('no measures');
            return;
          }
          if (NOC.MATERIAL.V3.getDimensions(this.materials).length <= 0) {
            // console.log('no dimensions');
            return;
          }
          const setDataDomain = NOC.MATERIAL.V3.getTargetSetData(this.materials);
          if (setDataDomain && this.targetSetDataValue === '') {
            return;
          }
          if (NOC.MATERIAL.V3.getTargetDate(this.materials) && this.targetDateValue === '') {
            return;
          }
          // データを取得する関数を呼び出す。
          this.loading = true;
          const api = new API();
          const requestData = {
            materilas: this.materials,
            values: {
              setData: this.targetSetDataValue,
              date: this.targetDateValue,
            },
          };
          const requestDataStr = JSON.stringify(requestData);
          if (requestDataStr === this.requestDataBack) {
            return;
          }
          this.requestDataBack = requestDataStr;
          const res = await api.post<models.VGetGraphData, models.VReturnGraphData>('gadget/basic_graph', requestData);
          // console.log(res);
          // console.log(JSON.stringify(res));
          if (res.result) {
            this.resData = res.data;
            // this.$emit('setNowData', this.resData);
            // 日毎設定で楽々30000になるため設定しない
            this.setChartJsData(this.resData.graphData);
          } else {
            // this.error = true;
          }
          this.loading = false;
        } else {
          // this.mode = NODATA;
        }
      } catch (e) {
        console.log(e);
        this.frameData.error = true;
      }
    },
    setChartJsData(gadgetDatas: models.IGraphData[]) {
      // console.log('setChartJsData');
      const datasets = [] as any[];
      let labels = [] as any[];
      try {
        this.frameData.error = false;
        const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
        if (gadgetDatas) {
          // 図ごとの処理
          switch (this.selectGraphs[0].key) {
            case NOC.CHARTS.BAR:
            case NOC.CHARTS.LINE:
            case NOC.CHARTS.HORIZONTALBAR:
              tmpOptionObj.scales.yAxes[0].display = true;
              tmpOptionObj.scales.xAxes[0].display = true;
              break;
          }

          // x軸の作成
          let labelsFunction = (v: models.IGraphData[]) => (v.map((y) => (y.label)));

          for (const dimension of NOC.MATERIAL.V3.getDimensions(this.materials)) {
            // this.detailIcon = false;
            switch (dimension.id) {
              case 16: {
                labelsFunction = (v: models.IGraphData[]) => (v.map((y) => ( `${Number(y.label.substr(y.label.length - 2, 2))}月`)));
                const ticksObj = {
                  callback(label: any, index: any, ylabels: any[]) {
                    return (label).toString() + '時間';
                  },
                };
                switch (this.selectGraphValue) {
                  case NOC.CHARTS.BAR:
                  case NOC.CHARTS.LINE:
                    tmpOptionObj.scales.yAxes[0].ticks = ticksObj;
                    break;
                  case NOC.CHARTS.HORIZONTALBAR:
                    tmpOptionObj.scales.xAxes[0].ticks = ticksObj;
                    break;
                }
                break;
              }
              case 17: {
                if (this.materials.find((v) => (v.id === 4))) {
                  labelsFunction = (v: models.IGraphData[]) => (v.map((y) => ( `${y.label.substr(5, 5)}日`)));
                } else if (this.materials.find((v) => (v.id === 5))) {
                  labelsFunction = (v: models.IGraphData[]) => (v.map((y) => ( `${y.label.substr(8, 2)}日`)));
                }
                const ticksObj = {
                  callback(label: any, index: any, ylabels: any[]) {
                    return (label).toString() + '時間';
                  },
                };
                switch (this.selectGraphValue) {
                  case NOC.CHARTS.BAR:
                  case NOC.CHARTS.LINE:
                    tmpOptionObj.scales.yAxes[0].ticks = ticksObj;
                    break;
                  case NOC.CHARTS.HORIZONTALBAR:
                    tmpOptionObj.scales.xAxes[0].ticks = ticksObj;
                    break;
                }
                break;
              }
              case 18: {
                // this.detailIcon = true;
                labelsFunction = (v: models.IGraphData[]) => (v.map((y) => (`${y.label}時`)));
                const ticksObj = {
                  stepSize: 0.25,
                  callback(label: any, index: any, ylabels: any[]) {
                    // console.log('label:', label, 'index', index, 'labels', labels);
                    return (label * 4 * 15).toString() + '分';
                  },
                };
                switch (this.selectGraphValue) {
                  case NOC.CHARTS.BAR:
                  case NOC.CHARTS.LINE:
                    tmpOptionObj.scales.yAxes[0].ticks = ticksObj;
                    break;
                  case NOC.CHARTS.HORIZONTALBAR:
                    tmpOptionObj.scales.xAxes[0].ticks = ticksObj;
                    break;
                }
                break;
              }
            }
          }
          labels = labelsFunction(gadgetDatas);
          labels = labels.map((v: string) => {
            return v.length <= 10 ? v : v.substring(0, 8) + '...';
          });
          let backgroundColor: any;
          // メジャー　就業時間とか
          for (const measure of NOC.MATERIAL.V3.getMeasures(this.materials) ) {
            let dataset: any;
            switch (measure.id) {
              case 7:
                // console.log('a', NOC.OPTION.V1.getValues(this.options, NOC.OPTION.V1.KEY.COLOR));
                if (NOC.OPTION.V1.getValues(this.options, NOC.OPTION.V1.KEY.COLOR)) {
                  backgroundColor = gadgetDatas.map((v, i) => (NOC.GRAPH.OPTIONS.BCOLOR[i % 5]));
                } else {
                  backgroundColor = gadgetDatas.map((v) => (NOC.GRAPH.OPTIONS.BCOLOR[0]));
                }
                dataset = {
                  label: measure.key,
                  backgroundColor,
                  data: gadgetDatas.map((v) => (Number(v.workTime) / 4)),
                };
                break;
              case 8:
                if (NOC.OPTION.V1.getValues(this.options, NOC.OPTION.V1.KEY.COLOR)) {
                  backgroundColor = gadgetDatas.map((v, i) => (NOC.GRAPH.OPTIONS.BCOLOR[i % 5]));
                } else {
                  backgroundColor = gadgetDatas.map((v) => (NOC.GRAPH.OPTIONS.BCOLOR[1]));
                }
                dataset = {
                  label: measure.key,
                  backgroundColor,
                  data: gadgetDatas.map((v) => {
                    // const value = Number(v.workTime) - Number(v.fixedTime);
                    const value = Number(v.overTime);
                    return value < 0 ? 0 : value / 4;
                  }),
                };
                break;
              case 19:
                dataset = {
                  label: measure.key,
                  backgroundColor: gadgetDatas.map((v) => ('#FF8080')),
                  data: gadgetDatas.map((v) => {
                    const value = Number(v.workTime) - Number(v.fixedTime);
                    return value >= 0 ? 0 : value / 4;
                  }),
                };
                break;
              case 20:
                dataset = {
                  label: measure.key,
                  backgroundColor: gadgetDatas.map((v) => (NOC.GRAPH.OPTIONS.BCOLOR[3])),
                  data: gadgetDatas.map((v) => {
                    return Number(v.fixedTime) / 4;
                  }),
                };
                // console.log(dataset);
                break;
            }

            if (dataset) {
              datasets.push(dataset);
            }
          }
          // ディメンション
        }


        // options処理
        // todo:hideen optionsへ以降
        switch (this.selectGraphs[0].key) {
          case NOC.CHARTS.LINE:
            for (const dataset of datasets) {
              const linebackcolor = (colors: string[]) => (colors.map((color: string) => (this.hex2rgba(color, 0.5))));
              dataset.backgroundColor = linebackcolor(dataset.backgroundColor);
            }
            break;
        }
        // console.log('tmpOptionObj', tmpOptionObj);
        if (NOC.OPTION.V1.getValues(this.options, NOC.OPTION.V1.KEY.MIN_VALUE)) {
          for (const yAxe of tmpOptionObj.scales.yAxes) {
            yAxe.ticks.beginAtZero = true;
          }
        }

        if (NOC.OPTION.V1.getValues(this.options, NOC.OPTION.V1.KEY.LEGEND)) {
          tmpOptionObj.legend.display = true;
        }

        this.dataObj = {
          labels,
          datasets,
        };
        this.optionsObj = tmpOptionObj;
      } catch (e) {
        console.log(e);
        this.frameData.error = true;
      }
    },
    setOptions() {
      // options成型
      this.optionItems = NOC.OPTION.V1.createChoices(this.selectGraphValue, this.materials);

      // 特殊条件
      // メジャーが1個の場合のみカラー選択可能
      if (NOC.MATERIAL.V3.getMeasures(this.materials).length !==  1) {
        this.optionItems = this.optionItems.filter((v) => (v.key !== NOC.OPTION.V1.KEY.COLOR));
      }

      this.options = NOC.OPTION.V1.createOptions(this.options, this.optionItems);
    },
    hex2rgba(hex: string, alpha = 1) {
      // ロングバージョンの場合（例：#FF0000）
      let r = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
      let c = null;
      if (r) {
          c = r.slice(1, 4).map((x) => (parseInt(x, 16)));
      }
      // ショートバージョンの場合（例：#F00）
      r = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
      if (r) {
          c = r.slice(1, 4).map((x) => (0x11 * parseInt(x, 16)));
      }
      // 該当しない場合は、nullを返す.
      if (!c) {
          return null;
      }
      return `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${alpha})`;
    },
    closeSelect() {
      this.selectorshow = false;
    },
  },
});
